export enum ValidInvalid {
    Valid = 'Valid',
    Invalid = 'Invalid'
}

